import css from "standard/css";

const style = css`
  .performance {
    width: 300px !important;
  }
`;

export default style;
